/**
 * Encensoria — Newsletter forms wiring
 * Tout form portant data-newsletter-form="source-name" :
 *   1. POST direct Klaviyo Subscribe API (garanti, source en custom property)
 *   2. POST Shopify /contact en best-effort (crée Customer si possible)
 *   3. Redirect vers /pages/bienvenue-cercle-encensoria après 700ms
 */
(function() {
  var COMPANY_ID = 'VbMWDG';
  var LIST_ID = 'Ta5y9p';
  var WELCOME_URL = '/pages/bienvenue-cercle-encensoria';
  var REDIRECT_DELAY = 700;
  var KLAVIYO_REVISION = '2024-10-15';

  function subscribeKlaviyo(email, source) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { source: source, signup_via: 'website-form' }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      })
    }).catch(function(err) { console.warn('[Encensoria] Klaviyo subscribe failed', err); });
  }

  function wireForm(form) {
    if (form.dataset.encWired === '1') return;
    form.dataset.encWired = '1';
    var source = form.getAttribute('data-newsletter-form') || 'website';

    form.addEventListener('submit', function(e) {
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value) return;
      e.preventDefault();
      var email = emailInput.value.trim();
      var btn = form.querySelector('button[type="submit"]') || form.querySelector('button');
      var origBtnHtml = btn ? btn.innerHTML : null;
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle"><polyline points="20 6 9 17 4 12"/></svg>';
      }

      // 1. Klaviyo direct (priorité — garantit l'arrivée dans la liste)
      subscribeKlaviyo(email, source);

      // 2. Shopify form (best-effort — crée le Customer pour intégration native)
      try {
        var fd = new FormData(form);
        fetch(form.action || '/contact', { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } }).catch(function() {});
      } catch (err) {}

      // 3. Redirect garanti
      setTimeout(function() {
        window.location.href = WELCOME_URL;
      }, REDIRECT_DELAY);
    });
  }

  function init() {
    // Match form[data-newsletter-form] OU wrapper [data-newsletter-form] avec form descendant
    document.querySelectorAll('[data-newsletter-form]').forEach(function(el) {
      var form = el.tagName === 'FORM' ? el : el.querySelector('form');
      if (!form) return;
      if (!form.hasAttribute('data-newsletter-form')) {
        form.setAttribute('data-newsletter-form', el.getAttribute('data-newsletter-form'));
      }
      wireForm(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public re-init pour formulaires ajoutés dynamiquement (shortcodes article)
  window.encensoriaWireNewsletter = init;
})();
